var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('font-awesome-icon',{style:({ color: '#ed5005 ' }),attrs:{"id":"cart","icon":"shopping-basket"}}),_c('div',[_c('h4',{staticClass:"cart-amount-number",attrs:{"id":"cart-items"}},[_vm._v(_vm._s(_vm.itemCount))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }